import {
    Box,
    Dialog,
    Slide,
    Typography,
    makeStyles
} from "@material-ui/core";
import { HighlightOff } from "@material-ui/icons";
import { forwardRef } from "react";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import { BrandButton, SecondaryBrandButton } from "../CoreComponents/BrandButton";
import SaveIcon from '@material-ui/icons/SaveOutlined';

const Transition = forwardRef((props, ref) => (
    <Slide direction="up" ref={ref} {...props} />
));

const useStyles = makeStyles((theme) => ({
    close: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        marginLeft: 'auto',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    contentWrapper: {
        padding: theme.spacing(2),
        width: '60vw',
        height: '60vh',
        display: 'flex',
        flexDirection: 'column'
    },
    header: {
        fontSize: '20px',
        fontWeight: 600
    },
    customInputDataWrapper: {
        display: 'flex',
        alignItems: 'center'
    },
    columnHeader: {
        fontWeight: 500,
        flex: 1,
    },
    headerSectionWrapper: {
        marginBottom: theme.spacing(2),
        display: 'flex',
        gap: theme.spacing(2),
        flexDirection: 'column'
    },
    warningMessage: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        color: theme.palette.primary.attention,
        marginRight: 'auto'
    },
    dialog: {
        '& .MuiDialog-paper': {
            border: `1px solid ${theme.palette.primary.borderStroke}`
        }
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.primary.borderStroke}`
    },
    saveButton: {
        marginLeft: theme.spacing(2)
    },
    modalHeader: {
        display: 'flex',
        padding: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.primary.borderStroke}`
    }
}));

const CustomModal = ({
    open,
    onClose,
    children,
    hideCloseIcon,
    headerText,
    subHeaderText,
    warningMessage,
    disabledSaveButton,
    onSaveChanges
}) => {
    const styles = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            maxWidth={false}
            className={styles.dialog}
        >
            <Box className={styles.modalHeader}>
                <Typography variant="h1" className={styles.header}>
                    {headerText}
                </Typography>
                {!hideCloseIcon && (
                    <HighlightOff
                        color='primary'
                        className={styles.close}
                        onClick={onClose}
                    />
                )}
            </Box>
            <Box className={styles.contentWrapper}>
                <Box className={styles.headerSectionWrapper}>
                    {subHeaderText && (
                        <Typography variant="body2">
                            {subHeaderText}
                        </Typography>
                    )}
                    <Box className={styles.customInputDataWrapper}>
                        <Typography className={styles.columnHeader}>
                            Account Holders
                        </Typography>
                        <Typography className={styles.columnHeader}>
                            Revenue
                        </Typography>
                    </Box>
                </Box>

                {children}

            </Box>
            <Box className={styles.footer}>
                {warningMessage && (
                    <Typography variant="body2" className={styles.warningMessage}>
                        <ReportProblemOutlinedIcon />
                        {warningMessage}
                    </Typography>
                )}
                <SecondaryBrandButton
                    className={styles.cancelButton}
                    onClick={onClose}
                >
                    Cancel
                </SecondaryBrandButton>
                <BrandButton
                    className={styles.saveButton}
                    startIcon={<SaveIcon />}
                    onClick={onSaveChanges}
                    disabled={disabledSaveButton}
                >
                    Save Changes
                </BrandButton>
            </Box>
        </Dialog>
    )
}

export default CustomModal;